import styles from "../creditreport.module.css";

const GoalRow = ({ label, pct, iconBg, icon }) => {
    return (<div className={styles.goalRow}>
        <div className={styles.goalIconSm} style={{ background: iconBg }}>{icon}</div>
        <div className={styles.goalNameRow}>
            <span className={styles.goalNameText}>{label}</span>
            <div className={styles.goalBarBg}>
                <div className={styles.goalBarFill} style={{ width: `${pct}%` }} />
            </div>
        </div>
        <span className={styles.goalPctText}>{pct}%</span>
    </div>);
}

export default GoalRow;